var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-row',_vm._l((_vm.stations),function(station){return _c('summary-station-card',{key:station.id,attrs:{"station":station,"tasks":_vm.tasks}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }